import React from 'react'
import ModalApp from './shared/modal/ModalApp'
import { notAllowedServiceMessage } from '../utils/confirmationMessage';
import warning from "../assets/images/redirection-warning.svg";


const NotAllowedServiceModal = ({ show, onClose, onSubmit }) => {
    const handleClose = () => {
        onClose(false);
    }
    return (
        <>
            <ModalApp show={show} onClose={handleClose} saveBtnTitle={"Go Back to Available Service"} onSave={onSubmit}
                hideCancelBtn={true} modalStyle={'not-allowed-service-modal'} saveBtnStyle={'not-allowed-service-save-btn'} >
                <div className='not-allowed-service-container'>
                    <div className='warning-body'>
                        <span className='warning-icon'>
                            <img src={warning} alt='warning icon' />

                        </span>
                        <span className='warning-text'>
                            <b>{notAllowedServiceMessage('boldText')}</b> <br/>
                            {notAllowedServiceMessage('paragraphOne')}
                        </span>
                    </div>
                </div>
            </ModalApp>
        </>
    )
}

export default NotAllowedServiceModal